// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

button {
    border-radius: 5px;
    padding: 3px 10px 2px;
    border: 1.5px solid #200;
    background-color: #f0f0f0;
    color: #333;
    font-family: inherit;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.05s ease;
}


button:hover {
    background-color: #ddd;
    border-color: #444;
    color: #000;
}


button:active {
    background-color: #bbb;
    border-color: #222;
    transform: scale(0.98);
}


button:focus-visible {
    outline: 1px solid #007BFF;
    outline-offset: 1px;
}


button:disabled {
    background-color: #f5f5f5;
    border-color: #ccc;
    color: #aaa;
    cursor: not-allowed;
}


/* AI says to move this to Rules and Controls, but not here.. TBD */
.edit_button {  
	display: inline-block;
	width: 68px;
	margin: 16px 0;
	margin-right: 10px;
}


.btn-sm {
    font-size: 11px;
    padding: 2px 8px 1px;
}


.selected {
    background-color: var(--color-selected-bg, #c8c8c8);
    border-color: var(--color-selected-border, #999);
    color: #000;
}

.selected:hover {
    background-color: var(--color-selected-hover-bg, #b8b8b8);
    border-color: var(--color-selected-hover-border, #777);
}`, "",{"version":3,"sources":["webpack://./code/styles/buttons.css"],"names":[],"mappings":";;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;;AAGA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;;AAGA,mEAAmE;AACnE;CACC,qBAAqB;CACrB,WAAW;CACX,cAAc;CACd,kBAAkB;AACnB;;;AAGA;IACI,eAAe;IACf,oBAAoB;AACxB;;;AAGA;IACI,mDAAmD;IACnD,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,yDAAyD;IACzD,sDAAsD;AAC1D","sourcesContent":["\n\nbutton {\n    border-radius: 5px;\n    padding: 3px 10px 2px;\n    border: 1.5px solid #200;\n    background-color: #f0f0f0;\n    color: #333;\n    font-family: inherit;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.05s ease;\n}\n\n\nbutton:hover {\n    background-color: #ddd;\n    border-color: #444;\n    color: #000;\n}\n\n\nbutton:active {\n    background-color: #bbb;\n    border-color: #222;\n    transform: scale(0.98);\n}\n\n\nbutton:focus-visible {\n    outline: 1px solid #007BFF;\n    outline-offset: 1px;\n}\n\n\nbutton:disabled {\n    background-color: #f5f5f5;\n    border-color: #ccc;\n    color: #aaa;\n    cursor: not-allowed;\n}\n\n\n/* AI says to move this to Rules and Controls, but not here.. TBD */\n.edit_button {  \n\tdisplay: inline-block;\n\twidth: 68px;\n\tmargin: 16px 0;\n\tmargin-right: 10px;\n}\n\n\n.btn-sm {\n    font-size: 11px;\n    padding: 2px 8px 1px;\n}\n\n\n.selected {\n    background-color: var(--color-selected-bg, #c8c8c8);\n    border-color: var(--color-selected-border, #999);\n    color: #000;\n}\n\n.selected:hover {\n    background-color: var(--color-selected-hover-bg, #b8b8b8);\n    border-color: var(--color-selected-hover-border, #777);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
